import React from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const useStyle = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2, 0),
    },
    content: {
        margin: theme.spacing(2),
        color: '#4A4A4A',
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        textAlign: 'left',
        fontFamily: 'Roboto'
    },
    icon: {
        color: "#2972CE",
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px 12px',
        justifyContent: 'space-between',
    },
    errorText: {
        background: '#C62930',
    },
    warningText: {
        background: '#2972CE',
    },
    errorSection: {
        border: '1px solid #C62930',
        borderRadius: theme.spacing(0.5),
        display: 'flex',
        boxSizing: 'borderBox'
    },
    warningSection:{
        border: '1px solid #2972CE',
        borderRadius: theme.spacing(0.5),
        display: 'flex',
        boxSizing: 'borderBox'
    },
    headerContent: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        margin: '4px 16px 0px',
        color: '#4A4A4A',
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        textAlign: 'left'
    }
}))

function Banner({ text, isError, header, isPasswordUpdateBanner }) {
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <div className={isError || isPasswordUpdateBanner ? classes.errorSection : classes.warningSection}>
                <div className={clsx(classes.wrapper, isError || isPasswordUpdateBanner ? classes.errorText : classes.warningText)}>
                    {
                        isError ?
                            <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7812 14.7812L11.2812 1.75C10.7188 0.78125 9.25 0.75 8.6875 1.75L1.1875 14.7812C0.625 15.75 1.34375 17 2.5 17H17.4688C18.625 17 19.3438 15.7812 18.7812 14.7812ZM10 12.0625C10.7812 12.0625 11.4375 12.7188 11.4375 13.5C11.4375 14.3125 10.7812 14.9375 10 14.9375C9.1875 14.9375 8.5625 14.3125 8.5625 13.5C8.5625 12.7188 9.1875 12.0625 10 12.0625ZM8.625 6.90625C8.59375 6.6875 8.78125 6.5 9 6.5H10.9688C11.1875 6.5 11.375 6.6875 11.3438 6.90625L11.125 11.1562C11.0938 11.375 10.9375 11.5 10.75 11.5H9.21875C9.03125 11.5 8.875 11.375 8.84375 11.1562L8.625 6.90625Z" fill="#2B2B2B" />
                            </svg>
                            :
                            isPasswordUpdateBanner ?
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" >
                                    <circle cx="12" cy="12" r="10" fill="white" stroke='#C62930'/>
                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                    fill='#C62930'/>
                                </svg>
                                : 
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25ZM8 3.6875C8.71875 3.6875 9.3125 4.28125 9.3125 5C9.3125 5.75 8.71875 6.3125 8 6.3125C7.25 6.3125 6.6875 5.75 6.6875 5C6.6875 4.28125 7.25 3.6875 8 3.6875ZM9.75 11.625C9.75 11.8438 9.5625 12 9.375 12H6.625C6.40625 12 6.25 11.8438 6.25 11.625V10.875C6.25 10.6875 6.40625 10.5 6.625 10.5H7V8.5H6.625C6.40625 8.5 6.25 8.34375 6.25 8.125V7.375C6.25 7.1875 6.40625 7 6.625 7H8.625C8.8125 7 9 7.1875 9 7.375V10.5H9.375C9.5625 10.5 9.75 10.6875 9.75 10.875V11.625Z" fill="#fafafa" />
                                </svg>
                    }
                </div>
                <div>
                    {
                        header && <p className={classes.headerContent}>{header}</p>
                    }
                    <p className={`body2 ${classes.content}`}>
                        {text}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Banner